import FormOrderPriceRegion from './FormOrderPriceRegion'
import { queryAll, toggleClass } from '../utils/dom'

const defaults = {
    skipFirst: true
}

export default class FormOrderPriceRegionCountry extends FormOrderPriceRegion {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            originCountry: null,
            checkCountry: null,
        }
    }

    calculate() {
        let total = 0
        const countries = queryAll('input[type="checkbox"]', this.element)
            .filter(element => element.checked)

        if (this.ref.originCountry.checked) {
            total += parseInt(this.ref.originCountry.dataset.price)
        } else if (this.ref.checkCountry.checked) {
            total += countries
                .filter((element, index) => (this.options.skipFirst && index > 0) || !this.options.skipFirst) // first country included in base price
                .map(element => parseInt(element.dataset.price))
                .reduce((acc, item) => acc + item, 0)
        }

        const first = this.element.querySelector('.is-first input')

        if (first && !first.checked) {
            first.parentNode.classList.remove('is-first')
        }

        if (((first && !first.checked) || !first) && countries.length && this.ref.checkCountry) {
            countries[0].parentNode.classList.add('is-first')
        }

        toggleClass(this.element, 'is-multiple', countries.length > 0 && this.ref.checkCountry.checked)

        this.price = total

        this.emit('change', {
            value: this.price
        })
    }
}
